const initialState = {
  error: '',
  data: null,
  answers: [],
};

export const setInterviewFinalQuestions = (state, { payload }) => {
  const { data, error } = payload;
  return {
    ...state,
    data,
    error,
  };
};

export const setInterviewFinalQuestionAnswer = (state, { payload }) => {
  const { answers } = state;
  const newArray = answers.concat([payload]);
  return {
    ...state,
    answers: newArray,
  };
};

export const clearInterviewFinalQuestionAnswer = (state) => {
  return {
    ...state,
    answers: [],
  };
};

export default initialState;
